export default "__VITE_ASSET__BdE0EfmY__"